<template>
    <div>
        <div class="tw-font-bold">
            Arbeitsstunden pro Wochentag
        </div>
        <table class="tw-table-auto tw-mt-2">
            <thead>
                <tr>
                    <th v-for="(day, index) in days" class="tw-text-right">
                        <label class="tw-font-bold" :for="name + '_' + index" v-text="day"></label>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td v-for="(day, index) in days" class="tw-border">
                        <input :id="name + '_' + index"
                               class="tw-py-2 tw-px-2 tw-w-12 tw-text-right"
                               type="number"
                               step="0.1"
                               min="0"
                               max="10"
                               v-model="values[index]"
                               :name="name + '[' + index + ']'"
                               style="-webkit-appearance: none; -moz-appearance: textfield;"
                        >
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="tw-mt-2 tw-mb-2">
            <span class="tw-font-bold">Stunden gesamt:</span>
            <span>
                {{ totalHours }}h
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DailyWorktimeSelect",

        props: {
            name: {
                type: String,
                required: true,
            },
            initialValues: {
                type: Array,
                required: false
            }
        },

        data() {
            return {
                days: [
                    'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So',
                ],
                values: !! this.initialValues && this.initialValues.length > 0
                    ? this.initialValues
                    : [8, 8, 8, 8, 8, 0, 0]
            }
        },

        computed: {
            totalHours() {
                let sum = 0;

                this.values.forEach(hours => {
                    if (! isNaN(parseFloat(hours))) {
                        sum += parseFloat(hours);
                    }
                });

                return sum;
            }
        }
    }
</script>